import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import KDSTopNav from '@decisiv/ui-components/lib/components/TopNav';

import { t } from '@lingui/macro';

import { CurrentInvitationContext } from 'utils/Invitation';
import { useCurrentUserContext } from 'utils/User';

import useSentinelTeam from 'hooks/useSentinelTeam';
import decisivLogo from './decisiv.png';

function BrandInfo(props) {
  /* istanbul ignore next -- @preserve */
  const { variant = 'full' } = props;
  const { sentinelTeam: invitationSentinelTeam } = useContext(
    CurrentInvitationContext,
  );
  const { needsSentinelTeam } = useCurrentUserContext();
  const userSentinelTeam = useSentinelTeam();

  const sentinelTeam = invitationSentinelTeam || userSentinelTeam;

  const teamName =
    needsSentinelTeam || !userSentinelTeam.hasSentinelTeam
      ? t`Sentinel Managed Care`
      : sentinelTeam?.name;
  const primaryText = variant === 'full' ? teamName : undefined;

  const applicationName = needsSentinelTeam
    ? t`Decisiv`
    : sentinelTeam?.applicationName ?? '';
  const secondaryText = variant === 'full' ? applicationName : undefined;
  return (
    <KDSTopNav.BrandInfo
      logo={needsSentinelTeam ? decisivLogo : sentinelTeam?.logo?.url}
      primaryText={primaryText}
      secondaryText={secondaryText}
    />
  );
}

BrandInfo.propTypes = {
  variant: PropTypes.oneOf(['full', 'compact']),
};

BrandInfo.defaultProps = {
  variant: 'full',
};

export default BrandInfo;
